module.exports = __webpack_public_path__ + "img/search.267172f9.png";